import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsActionItem from "./SetsActionItem"
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import SettingsForm from './SettingsForm'

class SetsAction extends SettingsForm {

  componentWillMount(){
    this.props.fetchSets('action');
    this.props.fetchSets('atype');
    this.setState({
      adding: false,
      data:{...this.newItem},
      errors: {}
    });
  }

  modelName = 'action'

  newItem = {
    action_desc: '',
    action_atype_id: 0,
    action_target: 0,
    action_admin: 0,
    action_sort: '0',
    action_name: '',
    action_text: ''
  };

  render() {
    if(isEmpty(this.props.actions.data)
      || isEmpty(this.props.atypes.data)
    ){
      return(<div>Не загружены данные</div>);
    }
    const actions = this.props.actions.data;
    const { search, sort } = this.props.actions;
    const atypes = this.props.atypes.data;
    const { data, errors } = this.state;

    var fltrActions = [];
    for(var key in actions){
      if(actions.hasOwnProperty(key)){
        var found = true;
        if(search !== ''){
          const searchValue = "" + actions[key].action_desc +
            actions[key].action_name;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(found){
          fltrActions.push(actions[key]);
        }
      }
    }

    const srtActions = fltrActions.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.action_id < b.action_id)
         return sort.asc ? -1 : 1
      if(a.action_id > b.action_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedActions = srtActions ? srtActions.map(action =>
      <SetsActionItem key={action.action_id}
        data={action}
        atypes={atypes}
      />
    ) : [];

    var atypesOpt = [];
    for (key in atypes){
      if(atypes.hasOwnProperty(key)) {
        atypesOpt.push({value:atypes[key].atype_id,label:atypes[key].atype_desc});
      }
    }
    atypesOpt.sort(sortOpts);

    const targetOpt = [
      {value: 0, label: 'modal'},
      {value: 1, label: 'link'},
      {value: 2, label: 'new tab'}
    ];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.action_desc}
              name="action_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </div>
        </td>
        <td>
          <Select
            clearable={false}
            options={atypesOpt}
            value={data.action_atype_id}
            onChange={e => this.updateSelect(e,'action_atype_id')}
            placeholder="Типы действия"
          />
        </td>
        <td>
          <Select
            clearable={false}
            options={targetOpt}
            value={data.action_target}
            onChange={e => this.updateSelect(e,'action_target')}
            placeholder="Target"
          />
        </td>
        <td>
          <input
            type="checkbox"
            checked={data.action_admin}
            name="action_admin"
            onChange={this.handleChBox}
          />
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.action_sort}
              name="action_sort"
              onChange={this.updateInput}
              placeholder="Сортировка"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.action_name}
              name="action_name"
              onChange={this.updateInput}
              placeholder="Action name"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.action_text}
              name="action_text"
              onChange={this.updateInput}
              placeholder="Action text"
            />
          </div>
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка действий</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrActions.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th
                className="col-sm-3"
                onClick={() => {this.handleSort('action_desc',this)}}
              >
                Название
              </th>
              <th
                className="col-sm-2"
                onClick={() => {this.handleSort('action_atype_id',this)}}
              >
                Тип действия
              </th>
              <th
                className="col-sm-1"
                onClick={() => {this.handleSort('action_target',this)}}
              >
                Target
              </th>
              <th
                className="col-sm-1"
                onClick={() => {this.handleSort('action_admin',this)}}
              >
                Admin
              </th>
              <th
                className="col-sm-1"
                onClick={() => {this.handleSort('action_sort',this)}}
              >
                Сортировка
              </th>
              <th
                className="col-sm-2"
                onClick={() => {this.handleSort('action_name',this)}}
              >
                Name
              </th>
              <th
                className="col-sm-2"
                onClick={() => {this.handleSort('action_text',this)}}
              >
                Text
              </th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedActions}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    actions: store.actions,
    atypes: store.atypes
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsAction);



// WEBPACK FOOTER //
// ./src/components/settings/SetsAction.js